import './NewPrivacyPolicy.scss'

const PrivacyPolicy = () => {
  return (
    <div className="new-privacy-policy">
      <h1>Privacy Policy</h1>
      <p>Last updated: September 17, 2026</p>
      <p>
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law protects
        You.
      </p>
      <p>
        We use Your Personal Data to provide and improve the Service. We
        collect, use, and disclose Your information as described in this Privacy
        Policy and, where required by applicable law, only where We have a valid
        legal basis to do so, including Your consent (where consent is
        required).
      </p>
      <h2>Interpretation and Definitions</h2>
      <h3>Interpretation</h3>
      <p>
        The words whose initial letters are capitalized have meanings defined
        under the following conditions. The following definitions shall have the
        same meaning regardless of whether they appear in singular or in plural.
      </p>
      <h3>Definitions</h3>
      <p>For the purposes of this Privacy Policy:</p>
      <ul>
        <li>
          <p>
            <strong>Account</strong> means a unique account created for You to
            access Our Service or parts of Our Service.
          </p>
        </li>
        <li>
          <p>
            <strong>Affiliate</strong> means an entity that controls, is
            controlled by, or is under common control with a party, where
            &quot;control&quot; means ownership of 50% or more of the shares,
            equity interest or other securities entitled to vote for election of
            directors or other managing authority.
          </p>
        </li>
        <li>
          <p>
            <strong>Application</strong> refers to HOST, the software program
            provided by the Company.
          </p>
        </li>
        <li>
          <p>
            <strong>Company</strong> (referred to as either &quot;the
            Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in
            this Privacy Policy) refers to GenbaNEXT, Row House No. 31A, New
            Dindoshi Royal Hills CHS Ltd., Next to NNP, Goregaon East,Mumbai,
            Maharashtra,400065.
          </p>
        </li>
        <li>
          <p>
            <strong>Country/State</strong> refers to: Telangana, India.
          </p>
        </li>
        <li>
          <p>
            <strong>Device</strong> means any device that can access the
            Service, such as a computer, a cell phone or a digital tablet.
          </p>
        </li>
        <li>
          <p>
            <strong>Personal Data</strong> (or &quot;Personal Information&quot;)
            is any information that relates to an identified or identifiable
            individual.
          </p>
          <p>
            We use &quot;Personal Data&quot; and &quot;Personal
            Information&quot; interchangeably unless a law uses a specific term.
          </p>
        </li>
        <li>
          <p>
            <strong>Service</strong> refers to the Application.
          </p>
        </li>
        <li>
          <p>
            <strong>Service Provider</strong> means any natural or legal person
            who processes the data on behalf of the Company. It refers to
            third-party companies or individuals employed by the Company to
            facilitate the Service, to provide the Service on behalf of the
            Company, to perform services related to the Service or to assist the
            Company in analyzing how the Service is used.
          </p>
        </li>
        <li>
          <p>
            <strong>Usage Data</strong> refers to data collected automatically,
            either generated by the use of the Service or from the Service
            infrastructure itself (for example, the duration of a page visit).
          </p>
        </li>
        <li>
          <p>
            <strong>User</strong> means any individual who accesses or uses the
            Service.
          </p>
        </li>
        <li>
          <p>
            <strong>You</strong> means the individual accessing or using the
            Service, or the company, or other legal entity on behalf of which
            such individual is accessing or using the Service, as applicable.
          </p>
        </li>
      </ul>
      <h2>Collecting and Using Your Personal Information</h2>
      <h3>Types of Data Collected</h3>
      <h4>Personal Data</h4>
      <p>
        While using Our Service, We may ask You to provide Us with certain
        personally identifiable information that can be used to contact or
        identify You. Personally identifiable information may include, but is
        not limited to:
      </p>
      <ul>
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Phone number</li>
        <li>Address, State, Province, ZIP/Postal code, City</li>
      </ul>
      <h4>Usage Data</h4>
      <p>Usage Data is collected automatically when using the Service.</p>
      <p>
        Usage Data may include information such as Your Device's Internet
        Protocol address (e.g. IP address), browser type, browser version, the
        pages of Our Service that You visit, the time and date of Your visit,
        the time spent on those pages, unique device identifiers and other
        diagnostic data.
      </p>
      <p>
        When You access the Service by or through a mobile device, We may
        collect certain information automatically, including, but not limited
        to, the type of mobile device You use, Your mobile device's unique ID,
        the IP address of Your mobile device, Your mobile operating system, the
        type of mobile Internet browser You use, unique device identifiers and
        other diagnostic data.
      </p>
      <p>
        We may also collect information that Your browser sends whenever You
        visit Our Service or when You access the Service by or through a mobile
        device.
      </p>
      <h4>Information Collected While Using the Application</h4>
      <p>
        While using Our Application, in order to provide features of Our
        Application, We may collect, with Your prior permission:
      </p>
      <ul>
        <li>
          <p>Information regarding Your location</p>
        </li>
        <li>
          <p>
            Pictures and other information from Your Device's camera and photo
            library
          </p>
        </li>
      </ul>
      <p>
        We use this information to provide features of Our Service and to
        improve and customize Our Service. The information may be uploaded to
        the Company's servers and/or a Service Provider's server or it may be
        simply stored on Your device.
      </p>
      <p>
        You can enable or disable access to this information at any time,
        through Your Device settings.
      </p>
      <h4>Tracking Technologies and Cookies</h4>
      <p>
        We use tracking technologies (such as cookies) to track the activity and
        to improve Our Service. The technologies We use may include:
      </p>
      <h3>Use of Your Personal Data</h3>
      <p>The Company may use Personal Data for the following purposes:</p>
      <ul>
        <li>
          <p>
            <strong>To provide and maintain Our Service</strong>, including to
            monitor the usage of Our Service.
          </p>
        </li>
        <li>
          <p>
            <strong>To manage Your Account:</strong> to manage Your registration
            as a user of the Service. The Personal Data You provide can give You
            access to different functionalities of the Service that are
            available to You as a registered user.
          </p>
        </li>
        <li>
          <p>
            <strong>For the performance of a contract:</strong> the development,
            compliance and undertaking of the purchase contract for the
            products, items or services You have purchased or of any other
            contract with Us through the Service.
          </p>
        </li>
        <li>
          <p>
            <strong>To contact You:</strong> To contact You by email, telephone
            calls, SMS, or other equivalent forms of electronic communication,
            such as a mobile application's push notifications regarding updates
            or informative communications related to the functionalities,
            products or contracted services, including the security updates,
            when necessary or reasonable for their implementation.
          </p>
        </li>
        <li>
          <p>
            <strong>To provide You</strong> with news, special offers, and
            general information about other goods, services and events which We
            offer that are similar to those that You have already purchased or
            inquired about. We send such marketing communications only where
            permitted by applicable law: where prior consent is required (for
            example, under the laws applicable in the EEA and the UK), We will
            send them only with Your consent; otherwise, We may send them until
            You opt out. You may opt out or withdraw Your consent at any time by
            using the unsubscribe link in any marketing email We send or by
            contacting Us.
          </p>
        </li>
        <li>
          <p>
            <strong>To manage Your requests:</strong> To attend and manage Your
            requests to Us.
          </p>
        </li>
        <li>
          <p>
            <strong>For business transfers:</strong> We may use Your Personal
            Data to evaluate or conduct a merger, divestiture, restructuring,
            reorganization, dissolution, or other sale or transfer of some or
            all of Our assets, whether as a going concern or as part of
            bankruptcy, liquidation, or similar proceeding, in which Personal
            Data held by Us about Our Service users is among the assets
            transferred.
          </p>
        </li>
        <li>
          <p>
            <strong>For other purposes</strong>: We may use Your information for
            other purposes, such as data analysis, identifying usage trends,
            determining the effectiveness of Our promotional campaigns, and
            evaluating and improving Our Service, products, services, marketing
            and Your experience.
          </p>
        </li>
      </ul>
      <p>We may share Your Personal Data in the following situations:</p>
      <ul>
        <li>
          <strong>With Service Providers:</strong> We may share Your Personal
          Data with Service Providers to monitor and analyze the use of Our
          Service, and to contact You.
        </li>
        <li>
          <strong>For business transfers:</strong> We may share or transfer Your
          Personal Data in connection with, or during negotiations of, any
          merger, sale of Company assets, financing, or acquisition of all or a
          portion of Our business to another company.
        </li>
        <li>
          <strong>With Affiliates:</strong> We may share Your Personal Data with
          Our affiliates, in which case We will require those affiliates to
          honor this Privacy Policy. Affiliates include Our parent company and
          any other subsidiaries, joint venture partners or other companies that
          We control or that are under common control with Us.
        </li>
        <li>
          <strong>With other users:</strong> If Our Service offers public areas,
          when You share Personal Data or otherwise interact in the public areas
          with other users, such information may be viewed by all users and may
          be publicly distributed outside the Service.
        </li>
        <li>
          <strong>With Your consent</strong>: We may disclose Your Personal Data
          for any other purpose with Your consent.
        </li>
      </ul>
      <h4>Text Messages Privacy Notice</h4>
      <p>
        You have the option to receive text (SMS) messages from Us. If You opt
        in to text messages, We will send You updates, notifications, and other
        communications as described below. When You opt in, We will collect and
        store the information You provide in connection with text messaging,
        such as Your phone number, the date and method of Your consent, and
        message delivery and read information.
      </p>
      <p>
        No mobile information will be shared with or sold to third parties or
        affiliates for marketing or promotional purposes. The phone numbers and
        consent records We collect for texting are never shared with anyone for
        any purpose, except the Service Providers that technically have to
        handle them to deliver the texts.
      </p>
      <p>
        Consent to receive text messages is not a condition of any purchase or
        use of Our Service. If You consent to receive SMS from Us, You agree to
        receive text messages from Us related to:
      </p>
      <ul>
        <li>Customer care and support</li>
        <li>
          Account notifications, such as activity, status, or renewal reminders
        </li>
        <li>Delivery notifications and updates on the status of a delivery</li>
        <li>
          Authentication messages, such as one-time passwords (OTP) and
          passcodes
        </li>
        <li>
          Security alerts, such as suspicious login attempts or unusual account
          activity
        </li>
        <li>
          Marketing and promotional offers, discounts, and other promotional
          content
        </li>
      </ul>
      <p>
        Reply STOP to opt-out. Reply HELP for support. Message &amp; data rates
        may apply. Messaging frequency may vary. Carriers are not liable for
        delayed or undelivered messages.
      </p>
      <h3>Retention of Your Personal Data</h3>
      <p>
        The Company will retain Your Personal Data only for as long as is
        necessary for the purposes set out in this Privacy Policy. We will
        retain and use Your Personal Data to the extent necessary to comply with
        Our legal obligations (for example, if We are required to retain Your
        data to comply with applicable laws), resolve disputes, and enforce Our
        legal agreements and policies.
      </p>
      <p>
        Where possible, We apply shorter retention periods and/or reduce
        identifiability by deleting, aggregating, or anonymizing data. Unless
        otherwise stated, the retention periods below are maximum periods
        (&quot;up to&quot;) and We may delete or anonymize data sooner when it
        is no longer needed for the relevant purpose. We apply different
        retention periods to different categories of Personal Data based on the
        purpose of processing and legal obligations:
      </p>
      <ul>
        <li>
          <p>Account Information</p>
          <ul>
            <li>
              User Accounts: retained for the duration of Your Account
              relationship plus up to 24 months after account closure to handle
              any post-termination issues or resolve disputes.
            </li>
          </ul>
        </li>
        <li>
          <p>Customer Support Data</p>
          <ul>
            <li>
              Support tickets and correspondence: up to 24 months from the date
              of ticket closure to resolve follow-up inquiries, track service
              quality, and defend against potential legal claims.
            </li>
            <li>
              Chat transcripts: up to 24 months for quality assurance and staff
              training purposes.
            </li>
          </ul>
        </li>
        <li>
          <p>Usage Data</p>
          <ul>
            <li>
              <p>
                Application usage statistics: up to 24 months to understand
                feature adoption and service improvements.
              </p>
            </li>
            <li>
              <p>
                Server logs (IP addresses, access times): up to 24 months for
                security monitoring and troubleshooting purposes.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        Usage Data is retained in accordance with the retention periods
        described above, and may be retained longer only where necessary for
        security, fraud prevention, or legal compliance.
      </p>
      <p>
        We may retain Personal Data beyond the periods stated above for
        different reasons:
      </p>
      <ul>
        <li>
          Legal obligation: We are required by law to retain specific data
          (e.g., financial records for tax authorities).
        </li>
        <li>
          Legal claims: Data is necessary to establish, exercise, or defend
          legal claims.
        </li>
        <li>
          Your explicit request: You ask Us to retain specific information.
        </li>
        <li>
          Technical limitations: Data exists in backup systems that are
          scheduled for routine deletion.
        </li>
      </ul>
      <p>
        You may request information about how long We will retain Your Personal
        Data by contacting Us.
      </p>
      <p>
        When retention periods expire, We securely delete or anonymize Personal
        Data according to the following procedures:
      </p>
      <ul>
        <li>
          Deletion: Personal Data is removed from Our systems and no longer
          actively processed.
        </li>
        <li>
          Backup retention: Residual copies may remain in encrypted backups for
          a limited period consistent with Our backup retention schedule and are
          not restored except where necessary for security, disaster recovery,
          or legal compliance.
        </li>
        <li>
          Anonymization: In some cases, We convert Personal Data into anonymous
          statistical data that cannot be linked back to You. This anonymized
          data may be retained indefinitely for research and analytics.
        </li>
      </ul>
      <h3>Transfer of Your Personal Data</h3>
      <p>
        Your information, including Personal Data, is processed at the Company's
        operating offices and in any other places where the parties involved in
        the processing are located. This means that this information may be
        transferred to — and maintained on — computers located outside of Your
        state, province, country or other governmental jurisdiction where the
        data protection laws may differ from those of Your jurisdiction.
      </p>
      <p>
        Where required by applicable law, We will ensure that international
        transfers of Your Personal Data are subject to appropriate safeguards
        and, where relevant, supplementary measures. The Company will take all
        steps reasonably necessary to ensure that Your data is treated securely
        and in accordance with this Privacy Policy and no transfer of Your
        Personal Data will take place to an organization or a country unless
        there are adequate controls in place, including the security of Your
        data and other personal information.
      </p>
      <h3>Delete Your Personal Data</h3>
      <p>
        You have the right to delete or request that We assist in deleting the
        Personal Data that We have collected about You.
      </p>
      <p>
        Our Service may give You the ability to delete certain information about
        You from within the Service.
      </p>
      <p>
        You may update, amend, or delete Your information at any time by signing
        in to Your Account, if You have one, and visiting the account settings
        section that allows You to manage Your personal information. You may
        also contact Us to request access to, correct, or delete any Personal
        Data that You have provided to Us.
      </p>
      <p>
        Please note, however, that We may need to retain certain information
        when We have a legal obligation or lawful basis to do so.
      </p>
      <h3>Disclosure of Your Personal Data</h3>
      <h4>Business Transactions</h4>
      <p>
        If the Company is involved in a merger, acquisition or asset sale, Your
        Personal Data may be transferred. We will provide notice before Your
        Personal Data is transferred and becomes subject to a different Privacy
        Policy.
      </p>
      <h4>Law Enforcement</h4>
      <p>
        Under certain circumstances, the Company may disclose Your Personal Data
        if required to do so by law or in response to valid requests by public
        authorities (e.g. a court or a government agency).
      </p>
      <h4>Other Legal Requirements</h4>
      <p>
        The Company may disclose Your Personal Data in the good-faith belief
        that such action is necessary to:
      </p>
      <ul>
        <li>Comply with a legal obligation</li>
        <li>Protect and defend the rights or property of the Company</li>
        <li>
          Prevent or investigate possible wrongdoing in connection with the
          Service
        </li>
        <li>
          Protect the personal safety of Users of the Service or the public
        </li>
        <li>Protect against legal liability</li>
      </ul>
      <h3>Security of Your Personal Data</h3>
      <p>
        The security of Your Personal Data is important to Us, but remember that
        no method of transmission over the Internet, or method of electronic
        storage, is 100% secure. While We strive to use commercially reasonable
        means to protect Your Personal Data, We cannot guarantee its absolute
        security.
      </p>
      <h2>Children's and Minors' Privacy</h2>
      <p>
        The Service is not directed to, and We do not knowingly collect Personal
        Information from, anyone under the age of 16.
      </p>
      <p>
        If You are a parent or guardian and You believe Your child has provided
        Us with Personal Information, please contact Us. If We become aware that
        We have collected Personal Information from anyone under the age of 16,
        We will take steps to remove that information from Our servers as soon
        as reasonably possible.
      </p>
      <p>
        Some countries and states set a higher age at which an individual can
        consent to the processing of their own Personal Information. Where We
        rely on consent as a legal basis and the law applicable to a User sets
        an age higher than 16, We may require the consent of that User's parent
        or guardian before We collect and use their Personal Information.
      </p>
      <h2>Links to Other Websites</h2>
      <p>
        Our Service may contain links to other websites that are not operated by
        Us. If You click on a third-party link, You will be directed to that
        third party's site. We strongly advise You to review the Privacy Policy
        of every site You visit.
      </p>
      <p>
        We have no control over and assume no responsibility for the content,
        privacy policies or practices of any third-party sites or services.
      </p>
      <h2>Changes to this Privacy Policy</h2>
      <p>
        We may update Our Privacy Policy from time to time. We will notify You
        of any changes by posting the new Privacy Policy on this page.
      </p>
      <p>
        We will let You know via email and/or a prominent notice on Our Service,
        prior to the change becoming effective and update the &quot;Last
        updated&quot; date at the top of this Privacy Policy.
      </p>
      <p>
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </p>
      <h2>Contact Us</h2>
      <p>
        If You have any questions about this Privacy Policy, You can contact Us:
      </p>
      <ul>
        <li>By email: collector-nml@telangana.gov.in</li>
      </ul>
    </div>
  )
}

export default PrivacyPolicy
